// External libraries
import React from 'react';

// Internal modules
import { Container, Spinner, SpinnerContainer } from './StyledComponents';

export const WalletsListLoading = (): React.ReactElement => (
  <Container data-testid="wallets-list" role="region">
    <SpinnerContainer>
      <Spinner data-testid="wallets-list-spinner" aria-hidden="true" />
    </SpinnerContainer>
  </Container>
);
